:host {
   display: block;
}

@media (max-width: 768px) {
   ::slotted(.alert-button) {
      margin-top: 1rem !important;
      width: 100% !important;
      text-align: center;
      display: inline-grid !important;
   }
}
